import {Component, Input, OnInit, Output, Renderer2, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
// Services
import {RewardService} from '../../../../shared/services/reward.service';
// Data model
import {RewardModel} from '../../../../shared/services/data.model';
import {ClipService} from '../../../../shared/services/clip.service';
import {RewardsToasterService} from '../../../../shared/services/rewards-toaster.service';
import {RewardsToasterArgs, RewardsToasterType} from '../../../../shared/services/rewards-toaster.interface';
import {Router} from '@angular/router';
import {RewardsSummaryService} from "../../../../shared/services/rewards-summary.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {properties} from "../../../../../environments/properties";
import {ParamService} from "../../../../shared/services/param.service";

declare const $: any;

function _window(): any {
    return window;
}

@Component({
    selector: 'point-reward-card',
    templateUrl: './point-reward-card.component.html',
    styleUrls: ['./point-reward-card.component.scss']
})

export class PointRewardCardComponent implements OnInit {
    @Input() reward: RewardModel;
    @Input() disabledButton = false;
    public rewardDetail: string;
    public rewardDetailPath: string = '';
    public rewardNewRefreshDisabled = false;
    public sm = '575px';
    public md = '768px';
    private imagePath: string = window['AB']['dMTProductCard'];
    public disableMulticlipRewardGallery: boolean;
    public disableToastmessageRewardPage: boolean;
    public returnTotalPoint = 0;
    @Input() userInfo: any;
    @Input() appHostURL: any;
    @Input() currentEnvironment: any;
    @Input() isPointScoreCardFlow: boolean;
    @Input() enableCashReward: boolean;
    clipInProgress = false;
    public disableCounter = false;
    isSomePointsExpired: boolean = false;
    @Input() rewardsResponseObj: any;
    @Input() isGetYourRewardFlow: boolean = false;
    @Output() callMyListApi= new EventEmitter();
    @Output() callMoreWaysToUseApi= new EventEmitter();
    @Output() callBoostYourPointsApi= new EventEmitter();
    @Input() isMoreWaysToUseFlow: boolean = false;
    @Input() isBoostYourPointsCardFlow;
    pageName: string = 'reward-card';
    @ViewChild('rewardCardElement') rewardCardElement!: ElementRef;
    public isEligibleProductActive: boolean = false;
    banner: any;
    isWODOffer: boolean = false;

    constructor(
        private _http: HttpClient,
        private _rewardService: RewardService,
        private _couponService: ClipService,
        private _rewardsToasterService: RewardsToasterService,
        private _renderer: Renderer2,
        private router: Router,
        private _rewardSummaryService: RewardsSummaryService,
        public authService: AuthService,
        public paramService: ParamService
    ) {
        this.disableMulticlipRewardGallery = false;
        this.disableToastmessageRewardPage = false;
    }

    ngOnInit() {
        this.banner = this.paramService.banner;
        this.isEligibleProductActive = true;
        this.disabledButton = false;
        this.reward.displayEndDate = this._rewardService.dateConversion(this.reward.displayEndDate);
        this.rewardDetailPath = this.reward.detailPath + '.' + this.reward.groceryRewardId + '.' + this.reward.offerPgm + '.html';
        this.isWODOffer = this.reward.offerProtoType ? this.reward.offerProtoType.indexOf('WOD') > -1 : false;
        $('.prompt-message__close-button').click(function () {
            $('#promptMessageModal').toast('hide');
        });
        $('#promptMessageModal a').attr('href', 'javascript:$(\'#rewards-selected-modal\').modal({show:true}); appConfigServiceRef.service.rewardsModalRefreshSource.next(true);');
        if (localStorage.getItem('rewardToastShow') && localStorage.getItem('rewardClipAndUnclipToastData') && localStorage.getItem('isRewardDetail') && !this.disableToastmessageRewardPage) {
            const getData = JSON.parse(localStorage.getItem('rewardClipAndUnclipToastData'));
            if (getData) {
                this.createToast(getData);
            }
            localStorage.removeItem('rewardClipAndUnclipToastData');
            localStorage.removeItem('rewardToastShow');
            localStorage.removeItem('isRewardDetail');
        }
        this._rewardSummaryService.$clipResponseDone.subscribe(data => {
            if(data) {
                this.clipInProgress = false;
            }
        });
    }

    focusOnReward(){
        // if(this.rewardCardElement){
        // setTimeout(() => {
        //     this.rewardCardElement.nativeElement.focus();
        //     }, 0);
        // }
    }

    public checkForExpirePoint() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            if (!this.disableToastmessageRewardPage) {
                let message = '';
                let type = RewardsToasterType.Error;
                this.clipInProgress = true;
                this.disableCounter = true;
                this.isSomePointsExpired = false;
                this._couponService.checkUnclipDetail(this.reward, this.userInfo, this.currentEnvironment)
                    .subscribe(data => {
                        if (data) {
                            const totalPoints = data.totalClippedPoints; //TODO: Use actual points instead of rewards;
                            const expiredPoints = data.expiredPoints; //TODO: Use actual points instead of rewards;
                            const nonexpiredPoints = totalPoints - expiredPoints;
                            this.returnTotalPoint = nonexpiredPoints;
                            if (data.isValidForUnClip) {
                                if (data.isPartiallyExpired) {
                                    if (nonexpiredPoints !== 0) {
                                        this.isSomePointsExpired = true;
                                        type = RewardsToasterType.PartiallyExpired;
                                        message = expiredPoints + ' of ' + totalPoints + ' Points have expired and cannot be reclaimed.';
                                        const toastArgs = {
                                            message: message,
                                            type: type,
                                            continueCb: () => (this.reward.usageType === 'M' ? this.unclipRewardMultiClip() : this.unclipReward()),
                                            closeCb: () => (this.clipInProgress = false)
                                        };
                                        this.disableCounter = false;
                                        this.createToast(toastArgs);
                                    }
                                } else {
                                    this.reward.usageType === 'M' ? this.unclipRewardMultiClip() : this.unclipReward();
                                }
                            } else {
                                type = RewardsToasterType.CompletelyExpired;
                                message = 'The Points used for this offer have expired and cannot be reclaimed.';
                                const toastArgs = {
                                    message: message,
                                    type: type
                                };
                                this.disableCounter = false;
                                this.createToast(toastArgs);
                            }
                        }
                    });
            } else {
                this.reward.usageType === 'M' ? this.unclipRewardMultiClip() : this.unclipReward();
            }
            this.disableCounter = false;
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }

    }
    private createToast(args: RewardsToasterArgs): void {
        let autoCloseTime = RewardsToasterService.autoCloseTime;
        if(args.type==RewardsToasterType.PartiallyExpired) {
            autoCloseTime = 0;
        }
        const toastElement: HTMLElement = this._rewardsToasterService.createToast(
            {message: args.message, type: args.type, autoCloseTime},
            args.continueCb ? args.continueCb : () => {
            },
            args.closeCb ? args.closeCb : () => {
            },
            true
        );
        const contentElement = document.querySelector('.point-reward-grid-container');
        if (toastElement && contentElement) {
            this._renderer.appendChild(contentElement, toastElement);
        }
    }

    public clipReward() {
        $('.reward-use-btn').attr('disabled', 'disabled');
        $('.btn-secondary').attr('disabled', 'disabled');
        $('.rewards-redeem-button').attr('disabled', 'disabled');
        this.disabledButton = true;
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this._couponService.clipReward(this.reward, this.updateStatisticsMulticlip.bind(this), this.rewardNewRefreshDisabled, this.userInfo, this.currentEnvironment, false, this.isPointScoreCardFlow, this.isBoostYourPointsCardFlow);
            this.setAnalyticsLinkClick(`rewards|rewards-use-${this.reward?.pointsRequired}-pts`);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }


    }

    public setTextForGroceryRewardAndMoreWaysToUse(){
        if(this.reward.programType == 'Points for Services' || this.reward.generalDisclaimer == 'Points for Services'){
            return 'View offer details';
        }else{
            return 'View eligible items';
        }
    }

    public clipRewardMultiClip() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this.clipInProgress = true;
            this.disableCounter = true;
            this._couponService.clipReward(this.reward, this.updateStatisticsMulticlip.bind(this), this.rewardNewRefreshDisabled , this.userInfo, this.currentEnvironment,false, this.isPointScoreCardFlow, this.isBoostYourPointsCardFlow);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }

    }

    public unclipRewardMultiClip() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this.clipInProgress = true;
            this.disableCounter = true;
            this._couponService.unclipRewardMulticlip(this.reward, this.updateStatisticsMulticlipUnclip.bind(this), this.rewardNewRefreshDisabled , this.userInfo, this.currentEnvironment,false, this.isPointScoreCardFlow);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }

    }

    public unclipReward() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this.clipInProgress = true;
            this._couponService.unclipReward(this.reward, this.updateStatisticsMulticlipUnclip.bind(this), this.rewardNewRefreshDisabled , this.userInfo, this.currentEnvironment,false, this.isPointScoreCardFlow);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }


    }

    public openRewardsModal() {
        this._couponService.openRewardsModalSource.next(true);
    }

    private updateStatisticsMulticlip() {
        if (!this.disableToastmessageRewardPage) {
            let pointsString;
            let toasterArgs;
            if(!this.isBoostYourPointsCardFlow) {
                pointsString = this.reward.pointsRequired > 1 ? ' Points. ' : ' Point. ';
                toasterArgs = {
                    message: 'Used ' + this.reward.pointsRequired + pointsString,
                    type: RewardsToasterType.SuccessGoToRewards,
                    continueCb: () => this.openRewardsModal()
                };
                this.createToast(toasterArgs);
            }
        } else {
            $('#promptMessageModal').toast('show');
        }
        this.disabledButton = false;
        this.disableCounter = false;
        $('.reward-use-btn').removeAttr('disabled');
        $('.btn-secondary').removeAttr('disabled');
        $('.rewards-redeem-button').removeAttr('disabled');
        if(this.isGetYourRewardFlow){
           this.callMyListApi.emit(true);
        }
        if(this.isMoreWaysToUseFlow){
            this.callMoreWaysToUseApi.emit(true);
        }
        if(this.isBoostYourPointsCardFlow) {
            this.callBoostYourPointsApi.emit(true);
        }
    }
    private updateStatisticsMulticlipUnclip() {
        this.disabledButton = false;
        this.disableCounter = false;
        $('.reward-use-btn').removeAttr('disabled');
        $('.btn-secondary').removeAttr('disabled');
        if (!this.disableToastmessageRewardPage) {
            let reclaimedPoints;
            if (this.isSomePointsExpired) {
                reclaimedPoints = this.returnTotalPoint;
            } else {
                reclaimedPoints = this.reward.pointsRequired;
            }
            const pointsString = this.reward.pointsRequired > 1 ? ' Points. ' : ' Point. ';
            const toasterArgs = {
                message: 'Reclaimed ' + reclaimedPoints + pointsString + 'It may take a few minutes to update your account.',
                type: RewardsToasterType.Success,
            };
            this.createToast(toasterArgs);
        }
        if(this.isGetYourRewardFlow){
            this.callMyListApi.emit(true);
        }
        if(this.isMoreWaysToUseFlow){
            this.callMoreWaysToUseApi.emit(true);
        }
    }
    public getImageUrl(id: string, viewport: string): String {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }

    openRewardDetail(scroll) {
        const scrollIndicator = JSON.parse(window.localStorage.getItem('scrollIndicator'));
        if(!scroll && scrollIndicator){
            window.localStorage.removeItem('scrollIndicator');
        }
        if(!scrollIndicator && scroll){
            window.localStorage.setItem('scrollIndicator', JSON.stringify(true)); 
        }
        const rewardsDetailsObj = {
            rewardId: this.isBoostYourPointsCardFlow ? this.reward.offerId : this.reward.groceryRewardId,
            rewardTs: this.reward,
            rewardOfferType: this.reward.offerPgm
        };
        this.trackAnalyticsCTA();
        this.router.navigate(['rewards/point-reward-details'], { queryParams: {rewardId: rewardsDetailsObj.rewardId, rewardOfferType: rewardsDetailsObj.rewardOfferType} });
    }
    triggerMyListAPI() {
        this.callMyListApi.emit(true);
    }

    public setAnalyticsLinkClick(linkName) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setLinkClickEvents(linkName);
        }
    }

    public trackAnalyticsCTA() {
        if (window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].pathSections) {
            const linkName = this.reward.programType == 'Points for Services' || this.reward.generalDisclaimer == 'Points for Services' ? 'view-offer-details' : 'view-eligible-items';
            window['AB']['DATALAYER'].analyticsCTATracking(`cta:${window['AB']['DATALAYER'].pathSections.join('-')}|link|rewards:${linkName}`);
        }
    }
}
